import MessageFormat from 'messageformat';
export const compileTemplate = function (template, locale) {
    locale = locale || 'en';
    return new MessageFormat(locale).setIntlSupport(true).compile(template);
};
